import React from 'react';
import { Calculator, Percent } from 'lucide-react';

/**
 * Компонент с секцией формулы расчета и состава тела
 */
const BodyCompositionSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  bmrFormulas 
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-blue-500" />
        Формула для расчета метаболизма
      </h3>
      
      <div className="grid grid-cols-1 gap-3 mb-4">
        {bmrFormulas.map((formula) => (
          <label 
            key={formula.id}
            className={`flex items-start p-3 rounded-lg border transition-colors cursor-pointer
              ${formData.formula === formula.id 
                ? 'bg-blue-100 border-blue-300 text-blue-800 dark:bg-blue-900/40 dark:border-blue-700 dark:text-blue-200'
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
          >
            <input
              type="radio"
              name="formula"
              value={formula.id}
              checked={formData.formula === formula.id}
              onChange={handleInputChange}
              className="form-radio mt-1"
            />
            <div className="ml-3">
              <span className="block font-medium text-gray-900 dark:text-white">
                {formula.name}
              </span>
              <span className="text-sm text-gray-600 dark:text-gray-400">
                {formula.description}
              </span>
            </div>
          </label>
        ))}
        {errors.formula && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.formula}
          </p>
        )}
      </div>
      
      {/* Поле процента жира в теле (только для формулы Кэтча-МакАрдла) */}
      {formData.formula === 'katch' && (
        <div className="mt-4">
          <label htmlFor="bodyFat" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Percent className="w-4 h-4 mr-2 text-blue-500" />
            Процент жира в организме
          </label>
          <div className="relative">
            <input
              type="number"
              id="bodyFat"
              name="bodyFat"
              value={formData.bodyFat}
              onChange={handleInputChange}
              className={`form-input w-full ${errors.bodyFat ? 'input-error' : ''}`}
              placeholder="Введите процент жира"
              min="3"
              max="70"
              step="0.1"
            />
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <span className="text-gray-500 dark:text-gray-400">%</span>
            </div>
          </div>
          {errors.bodyFat && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.bodyFat}
            </p>
          )}
          <p className="mt-2 text-xs text-blue-600 dark:text-blue-400">
            Типичные значения: 8-20% для мужчин, 15-30% для женщин. Если вы не знаете свой процент жира, 
            обратитесь к специалисту для измерения или выберите другую формулу расчета.
          </p>
        </div>
      )}

      <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
          Что такое базальный метаболизм (BMR)?
        </h4>
        <p className="text-xs text-blue-600 dark:text-blue-400">
          Базальный метаболизм (BMR) — это минимальное количество энергии, необходимое организму для 
          поддержания основных жизненных функций в состоянии полного покоя. Это калории, которые 
          ваш организм расходует, даже если вы просто лежите в кровати весь день.
        </p>
      </div>
    </div>
  );
};

export default BodyCompositionSection;